module.exports = __webpack_public_path__ + "static/media/clicky2.eb681fb2.gif";